import React, { useState, useEffect } from 'react';
import ButtonsForInt from '../../../../../../../dashboard/components/Profile/subcomponents/ButtonsForInt';
// import ClickMessageType from '../../../../../../../dashboard/components/Profile/subcomponents/ClickMessageType';
import CustomTopic from '../../../../../../../dashboard/components/Profile/subcomponents/CustomTopic';
import SelectVprop from '../../../../../../../dashboard/components/Profile/subcomponents/SelectVprop';
import LIlogo from '../../../../../../../../images/linkedinLogo.png'
import LinkedInHK from '../../../../../../../dashboard/components/Functions/Hotkeys/LinkedInHK';
import ContentGenerated from '../../../../../../../dashboard/components/Profile/subcomponents/ContentGenerated';
import GenerateButton from '../../../../../../../dashboard/components/Profile/subcomponents/GenerateButton';
import CopyAndFireButtons from '../../../../../../../dashboard/components/Profile/subcomponents/CopyAndFireButtons';
import { RefreshIcon } from '@heroicons/react/solid';
import BounceLoader from "react-spinners/BounceLoader";
import { css } from "@emotion/core";
import { regenInterests } from '../../../../../../../dashboard/components/Functions/AIFunctions/RegenInterests';
import Default from '../../../../../../../../images/default.png'

const override = css`
  display: inline-block;
  margin: 20px;
`;

const ProspectProfile = ({
        prospect, 
        auth, 
        FBvalueProp, 
        fbProfile,
        tokens,
        interestValues,
        callToAction,
        firstCopy,
        setProspectProfile,
        contacts,
        setInterests,
        interests
    }) => {

    const [ intVal, setIntVal ] = useState('')
    const onboarded = false
    // const [ onboarded, setOnboarded ] = useState(false)
    const shownButton = 'Short Intro'
    // const [ showProfileVpropAdd, setShowProfileVpropAdd ] = useState(false)
    const [ vProp, setVprop ] = useState ('')
    const [ contentGen, setContentGen] = useState('')
    const [ generating, setGenerating ] = useState(false)
    const [ editing, setEditing ] = useState(false)
    const [ clickedYesorNo, setClickedYesorNo ] = useState(false)
    const [ showBtn, setShowBtn ] = useState(true);
    // const [ interests, setInterests ] = useState(prospect.ProspectInterest)
    const [ intLoad, setIntLoad ] = useState(false)
    const setShowTooltip = false
    const valueIndex = localStorage.getItem('valueIndex') !== null ? localStorage.getItem('valueIndex') : 'default'

    const setShowProfileVpropAdd = () =>{

    }

    useEffect(() =>{
        const checkVprop = () =>{
            if(FBvalueProp.length === 1){
                setVprop(FBvalueProp[0])
                localStorage.setItem('valueIndex', 0)
            }
            else if(valueIndex !== null){
                setVprop(FBvalueProp[valueIndex])
            }
        }

        const showTooltipAndBtn = () =>{ 
            if((intVal !== '') && (vProp !== '') && (vProp !== undefined)){
                // setShowTooltip(true)
                setShowBtn(false)
            }else{
                // setShowTooltip(false)
                setShowBtn(true)
            }
        }

        const pauseGenerate = () =>{
            if(generating === true){
                // setShowTooltip(false)
                setShowBtn(true)
            }
        }

        const zeroTokens = () =>{
            if(tokens?.totalTokens < 1){
                setShowBtn(true)
            }
        }

        checkVprop()
        showTooltipAndBtn()
        pauseGenerate()
        zeroTokens()

    }, [valueIndex, setVprop, FBvalueProp, setShowBtn, tokens, intVal, vProp, generating])


    const selectedVprop = (e) =>{
        setVprop(FBvalueProp[e.currentTarget.value])
        // setValueIndex(e.currentTarget.value)
        localStorage.setItem('valueIndex', e.currentTarget.value)
    }

    // const Prospected = (contact, index) =>{
    //     FinishedProspecting(contact.id, profile)
    //     console.log(index)
    //     var next = index + 1
    //     // setProspectProfile(contacts[next])
    //     // setLinkedin(contacts[next].Linkedin)
    //     if(contacts[next] !== undefined){
    //         setProspectProfile(contacts[next])
    //         setLinkedin(contacts[next].Linkedin)
    //     } else {
    //         setProspectProfile()
    //         setLinkedin()
    //     }
    // }

    // console.log(prospect)

    return (
        <div className="flex">
            <div className=" w-1/2">
                <div className="border-2 border-gray-200 p-2 mb-4 rounded-md shadow hover:shadow-lg">
                    {/* Img and Name and Value Prop */}
                    <div className="flex">
                        {prospect?.contactImg.includes('proxycurl') ?
                        <img src={Default} className="h-20 rounded-full mr-4 " alt="logo"/>
                        :
                        <img src={prospect.contactImg} className="h-20 rounded-full mr-4 " alt="logo"/>
                        }
                        <div>
                        <h4 className="text-lg font-bold">{prospect?.ProspectName}</h4>
                        <div className="-mt-2">
                        <SelectVprop 
                        valueIndex={valueIndex}
                        selectedVprop={selectedVprop}
                        setShowProfileVpropAdd={setShowProfileVpropAdd}
                        onboarded={onboarded}
                        auth={auth}
                        FBvalueProp={FBvalueProp}
                        />
                        </div>
                        </div>
                    </div>
                </div>
                {/* Message type */}
                {/* <div className="border-2 border-gray-200 p-2 mb-4 rounded-md shadow hover:shadow-lg">
                    <div className="text-base font-semibold mb-2">
                        Choose a message type
                    </div>
                    <ClickMessageType 
                    setShownButton={setShownButton}
                    shownButton={shownButton}
                    onboarded={onboarded}
                    auth={auth}
                    />
                </div> */}
                {/* Interests */}
                <div
                className="shadow hover:shadow-lg py-1 px-2 border-gray-200 border-2 rounded-md"
                >
                    <div
                    className="mt-2 text-base font-semibold -mb-2"
                    >
                    Pick a Topic
                    </div>
                    {prospect.contactSummary?.length > 20 ?
                    <button 
                            className="float-right mr-0 -mt-5 focus:outline-none"
                            onClick={() =>regenInterests(
                                prospect.contactSummary, 
                                setInterests, 
                                prospect.id, 
                                fbProfile, 
                                setIntLoad,
                                auth,
                                prospect.id
                            )}
                        >
                        <RefreshIcon className="border-2 border-blue-600 h-7 p-0.5 rounded-md bg-blue-600 text-white hover:bg-blue-500"/>
                    </button>
                    :
                    null }
                    <div
                    className="-ml-4"
                    >
                        {intLoad ? 
                        <div className="text-center ml-10">
                        <BounceLoader size={75} css={override} color='#44A3CE'/>
                        </div>
                        :
                        <ButtonsForInt 
                        interests={interests}
                        auth={auth}
                        onboarded={onboarded}
                        setIntVal={setIntVal}
                        intVal={intVal}
                        />
                        }
                    </div>
                    <div
                    className="-ml-3"
                    >
                    <CustomTopic 
                    auth={auth}
                    onboarded={onboarded}
                    setIntVal={setIntVal}
                    intVal={intVal}
                    />
                    </div>
                </div>
                <LinkedInHK 
                    url={prospect.Linkedin}
                />
                {/* Contact Summary */}

                <div 
                className="my-2 border-2 border-gray-200 rounded-md p-2 hover:shadow-lg shadow"
                >
                    <div>
                        <div className="my-2 text-lg font-semibold">
                            Bio
                            <div className="float-right">
                            <a id="myLink" href={prospect.Linkedin} target="_blank" rel="noreferrer">
                                <img src={LIlogo} alt="forBio" className="h-6" />
                            </a>
                            </div>
                        </div>
                    </div>
                    {prospect.contactSummary.length > 10 ?
                    <div className="text-base">
                        {prospect.contactSummary}
                    </div>
                    :
                    <i>'No bio found'</i>
                    }
                </div>
            </div>
            <div className="w-1/2  ml-4 -mt-2">
            <div className="mb-2 text-right">
            <GenerateButton 
                shownButton={shownButton}
                profile={prospect}
                fbProfile={fbProfile}
                vProp={vProp}
                intVal={intVal}
                auth={auth}
                setContentGen={setContentGen}
                setGenerating={setGenerating}
                tokens={tokens}
                docId={prospect.id}
                LIurl={prospect.Linkedin}
                interests={prospect.ProspectInterest}
                foundInts={prospect.contactSummary}
                interestValues={interestValues}
                setBtnClicked={setClickedYesorNo}
                setShowTooltip={setShowTooltip}
                callToAction={callToAction}
                setEditing={setEditing}
                generating={generating}
                showBtn={showBtn}
                />
            </div>
            <div
            className="bg-white shadow sm:rounded-lg xs:mt-4 xs:ml-0 xs:w-full hover:shadow-lg border-2 border-gray-200"
            >
             <ContentGenerated 
             profile={prospect}
             contentGen={contentGen}
             generating={generating}
             editing={editing}
             setEditing={setEditing}
             setContentGen={setContentGen}
             fbProfile={fbProfile}
             auth={auth}
             docId={prospect.id}
             vProp={vProp}
             intVal={intVal}
             />
             <CopyAndFireButtons 
            contentGen={contentGen}
            generating={generating}
            fbProfile={fbProfile} 
            docId={prospect.id}
            vProp={vProp}
            intVal={intVal}
            shownButton={shownButton}
            firstCopy={firstCopy}
            profile={prospect}
            setBtnClicked={setClickedYesorNo}
            auth={auth}
            fireClicked={clickedYesorNo}
            />
            </div>
            </div>
            {/* <div className="bottom-0 my-0 fixed w-full flex flex-row-reverse bg-gray-900 h-14 left-0"> */}
            {/* </div> */}
        </div>
    )
}

export default ProspectProfile
